module.exports = __webpack_public_path__ + "img/2026-02-27d_2.027121cf.jpg";